function _instanceof(left, right) {
    "@swc/helpers - instanceof";
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
import { prepareWithSegments, layoutWithLines } from "@chenglou/pretext";
/** Common named HTML entities for the DOM-free decode fallback. */ var NAMED_ENTITIES = {
    amp: "&",
    lt: "<",
    gt: ">",
    quot: '"',
    apos: "'",
    nbsp: " ",
    ndash: "–",
    mdash: "—",
    hellip: "…",
    copy: "©",
    reg: "®",
    trade: "™",
    deg: "°",
    middot: "·",
    bull: "•",
    laquo: "«",
    raquo: "»",
    times: "×",
    divide: "÷",
    lsquo: "‘",
    rsquo: "’",
    ldquo: "“",
    rdquo: "”",
    euro: "€",
    pound: "£",
    cent: "¢",
    yen: "¥",
    sect: "§",
    para: "¶",
    plusmn: "±"
};
/**
 * Decodes HTML entities without a DOM, for headless/server-side rendering where
 * `DOMParser` may be absent. Handles numeric (`&#160;`/`&#xA0;`) and the common
 * named entities above; unknown or out-of-range entities are left as-is.
 * Exported for testing; not part of the package's public API.
 * @param {String} input tag-stripped text
 */ export function decodeEntities(input) {
    return input.replace(/&(#x[0-9a-fA-F]+|#[0-9]+|[a-zA-Z][a-zA-Z0-9]*);/g, function(match, code) {
        if (code[0] === "#") {
            var cp = code[1] === "x" ? parseInt(code.slice(2), 16) : parseInt(code.slice(1), 10);
            // Reject code points outside the Unicode range — String.fromCodePoint
            // throws on them; leave the raw entity in place instead.
            return cp <= 0x10ffff ? String.fromCodePoint(cp) : match;
        }
        var named = NAMED_ENTITIES[code];
        return named !== undefined ? named : match;
    });
}
/**
 * Strips HTML and "un-escapes" escape characters. Uses `DOMParser` when present
 * (browser / jsdom) for full entity coverage, falling back to a DOM-free decode
 * so text measurement works in any headless environment.
 * @param {String} input
 */ function htmlDecode(input) {
    if (input.replace(/\s+/g, "") === "") return input;
    var stripped = input.replace(/<[^>]+>/g, "");
    if (typeof DOMParser !== "undefined") {
        var doc = new DOMParser().parseFromString(stripped, "text/html");
        return doc.documentElement ? doc.documentElement.textContent : input;
    }
    return decodeEntities(stripped);
}
/**
 * Builds a CSS font shorthand string from a style object.
 * @param {Object} styleObj
 */ function buildFont(styleObj) {
    var style = styleObj["font-style"] || "normal";
    var variant = styleObj["font-variant"] || "normal";
    var weight = styleObj["font-weight"] || 400;
    var size = typeof styleObj["font-size"] === "string" ? styleObj["font-size"] : "".concat(styleObj["font-size"] || 10, "px");
    var family = styleObj["font-family"] || "sans-serif";
    return "".concat(style, " ").concat(variant, " ").concat(weight, " ").concat(size, " ").concat(family);
}
/**
 * Measures the width of a single text string using pretext.
 * @param {String} text
 * @param {String} font CSS font shorthand
 */ function measureWidth(text, font) {
    if (!text) return 0;
    var prepared = prepareWithSegments(text, font);
    var result = layoutWithLines(prepared, Infinity, 20);
    return result.lines.length ? result.lines[0].width : 0;
}
export default function(text) {
    var style = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var font = buildFont(style);
    if (_instanceof(text, Array)) return text.map(function(t) {
        return measureWidth(htmlDecode(t), font);
    });
    return measureWidth(htmlDecode(text), font);
}

//# sourceMappingURL=textWidth.js.map